import React, { useEffect, useState } from 'react';
const NAMES = ['María', 'Laura', 'Carolina', 'Alejandra', 'Gabriela', 'Luciana', 'Valeria', 'Daniela', 'Marcela', 'Patricia', 'Silvia', 'Andrea', 'Claudia', 'Romina', 'Verónica', 'Natalia', 'Florencia', 'Soledad', 'Cecilia', 'Mariana', 'Jorge', 'Fernando', 'Pablo', 'Roberto', 'Martín', 'Diego', 'Sebastián', 'Nicolás', 'Andrés', 'Gustavo'];
const CITIES = ['Ciudad de México 🇲🇽', 'Bogotá 🇨🇴', 'Santiago 🇨🇱', 'Lima 🇵🇪', 'Madrid 🇪🇸', 'Quito 🇪🇨', 'Montevideo 🇺🇾', 'Caracas 🇻🇪', 'San José 🇨🇷', 'Santo Domingo 🇩🇴', 'Guadalajara 🇲🇽', 'Medellín 🇨🇴', 'Valparaíso 🇨🇱', 'Arequipa 🇵🇪', 'Barcelona 🇪🇸', 'Guayaquil 🇪🇨', 'Panamá 🇵🇦', 'Asunción 🇵🇾', 'La Paz 🇧🇴', 'Managua 🇳🇮'];
const PRODUCTS = [{
  name: 'EDULABS MegaPack + Kit Táctico Pro',
  emoji: '🏆'
}, {
  name: 'EDULABS MegaPack Voley Listo',
  emoji: '🏐'
}];
const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
interface NotificationData {
  name: string;
  initial: string;
  city: string;
  product: {
    name: string;
    emoji: string;
  };
  timeAgo: number;
}
function generateRandomNotification(): NotificationData {
  const name = NAMES[Math.floor(Math.random() * NAMES.length)];
  const initial = LETTERS[Math.floor(Math.random() * LETTERS.length)];
  const city = CITIES[Math.floor(Math.random() * CITIES.length)];
  const product = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
  const timeAgo = Math.floor(Math.random() * 14) + 2;
  return {
    name,
    initial,
    city,
    product,
    timeAgo
  };
}
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [notification, setNotification] = useState<NotificationData | null>(null);
  useEffect(() => {
    if (isDismissed) return;
    let showTimeout: NodeJS.Timeout;
    let hideTimeout: NodeJS.Timeout;
    const cycleNotification = () => {
      setNotification(generateRandomNotification());
      setIsVisible(true);
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
        const nextDelay = 25000 + Math.floor(Math.random() * 20000);
        showTimeout = setTimeout(cycleNotification, nextDelay);
      }, 4000);
    };
    const initialTimeout = setTimeout(cycleNotification, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [isDismissed]);
  if (isDismissed || !notification) return null;
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 ease-in-out ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`} data-id="element-204">
      <div className="bg-[#16161F] border border-[#FF6B0033] rounded-xl shadow-2xl p-4 max-w-[300px] sm:max-w-[320px] relative pr-8" data-id="element-205">
        <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-[#B0B0C0] hover:text-white transition-colors p-1" aria-label="Cerrar notificación" data-id="element-206">
          ✕
        </button>
        <div className="flex items-center gap-2 mb-2" data-id="element-207">
          <div className="w-2 h-2 bg-[#FF6B00] rounded-full animate-pulse" data-id="element-208" />
          <span className="text-[#FF6B00] text-xs font-bold uppercase tracking-wider" data-id="element-209">
            Compra verificada
          </span>
        </div>
        <p className="text-white text-sm mb-1" data-id="element-210">
          <span className="font-bold" data-id="element-211">
            {notification.name} {notification.initial}.
          </span>{' '}
          de {notification.city}
        </p>
        <p className="text-[#B0B0C0] text-sm mb-2" data-id="element-212">
          compró{' '}
          <span className="text-[#FF6B00] font-bold" data-id="element-213">
            {notification.product.name} {notification.product.emoji}
          </span>
        </p>
        <p className="text-[#B0B0C0] opacity-70 text-xs" data-id="element-214">
          hace {notification.timeAgo} minutos
        </p>
      </div>
    </div>;
}